import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faTimesCircle, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons'

import * as uiMessageActions from 'redux/actions/UiMessageActions';

import { StoreModel } from 'models/StoreModel';
import { UiMessage, UiMessageType } from 'models/UiMessageModel';
import Translator from './Translator';

interface IState {
    curTime: Date;
    isActive: boolean;
}

interface IProps {
    uiMessages: UiMessage[],
    clear: typeof uiMessageActions.clearUiMessage
}

class UiMessageViewer extends React.Component<IProps, IState> {
    public readonly state: IState = {
        curTime: new Date(),
        isActive: false
    }

    getDiffToCurrentTime(date: Date) {
        return (new Date().getTime() - Math.abs(date.getTime())) / 1000;
    }

    componentDidMount() {
        setInterval(() => {
          let isActive =  !!this.props.uiMessages.find(uim => this.getDiffToCurrentTime(uim.received) < (uim.messageType === UiMessageType.success ? 3 : 10))
          this.setState({
            curTime : new Date(),
            isActive: isActive
          })
        }, 1000)
      }

    render() {
        return (
            <div className={'c-ui-message__wrapper'  + (this.state.isActive ? ' c-ui-message__enter-active' : ' c-ui-message__leave-active')}>
                <div className='c-ui-message__container o-container o-container--xs'>
                    <div className='c-ui-message__main'>
                        {this.props.uiMessages.map(uim =>
                            <div className="c-ui-message__item" key={uim.message}>
                                {uim.messageType === UiMessageType.success &&
                                    <FontAwesomeIcon className="c-ui-message__main--icon c-ui-message__main--icon-success" icon={faCheckCircle}></FontAwesomeIcon>
                                }
                                {uim.messageType === UiMessageType.warning &&
                                    <FontAwesomeIcon className="c-ui-message__main--icon c-ui-message__main--icon-warning" icon={faExclamationTriangle}></FontAwesomeIcon>
                                }
                                {uim.messageType === UiMessageType.error &&
                                    <FontAwesomeIcon className="c-ui-message__main--icon c-ui-message__main--icon-error" icon={faTimesCircle}></FontAwesomeIcon>
                                }
                                <Translator text={uim.message} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state: StoreModel) {
    return {
        uiMessages: state.uiMessages,
    };
}
function mapDispatchToProps(dispatch: Dispatch) {
    return {
        clear: bindActionCreators(uiMessageActions.clearUiMessage, dispatch),
    };
}
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UiMessageViewer);